import ArticleIcon from '@material-ui/icons/FormatAlignLeft';
import { APP_TYPES, roles } from '../../../config/constants';
import ScheduleList from '../ScheduleList';

const options = {
  appTypes: [APP_TYPES.ALL],
  allowedRoles: [roles.ADMIN, roles.BA, roles.JTI_TEAM, roles.RSM, roles.USER],
  label: 'Articles',
  subMenuName: 'scheduleList',
};

export default {
  list: ScheduleList,
  icon: ArticleIcon,
  name: 'admin/schedule/type/article',
  options,
};
